import Input from '../ui/Input';
import { useState } from 'react';

const AddNoteArea = ({
  value,
  onChange,
  className,
  hideTitle = false,
  rows = 3,
}) => {
  const [inputValue, setInputValue] = useState(value);

  return (
    <div className={className}>
      {!hideTitle && (
        <div className="font-semibold text-xs md:text-[15px] mb-2">
          Special Instructions
        </div>
      )}
      <Input
        className="text-sm resize-none rounded-lg"
        textArea
        rows={rows}
        type="text"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder="Add a note or special instruction here.."
        onBlur={(e) => onChange(e.target.value)}
      />
    </div>
  );
};

export default AddNoteArea;
